"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("element-closest");
require("./lib/AnalyticsStub");
require("./bootstrap/bnr2/_setup");
require("./bootstrap/bnr2/LiveProgramTitle");
require("imgix.js");
require("picturefill");
require("./bootstrap/bnr2/MenuHoverConfig");
require("./bootstrap/bnr2/MobileMenuToggleConfig");
require("./bootstrap/bnr2/ResponsiveMenuItemsConfig");
require("./bootstrap/bnr2/SearchToggleConfig");
require("./bootstrap/bnr2/PlayerFormConfig");
require("./bootstrap/bnr2/StickyNavConfig");
require("./bootstrap/bnr2/SubSubMenuToggleConfig");
require("./bootstrap/bnr2/AdConfig");
require("./bootstrap/bnr2/ProgramGuideConfig");
require("./bootstrap/bnr/Eggs");
require("./bootstrap/bnr2/cmp2");
require("./bootstrap/bnr/SocialSharingConfig");
var SimpleToggle_1 = __importDefault(require("./components/SimpleToggle"));
new SimpleToggle_1.default(".button-toggle", ".section-specials", {
    buttonToggleClassName: 'toggled',
    targetToggleClassName: 'toggled'
});
